import { contract } from '@aviv_price-pages/brand';
/**
 * Rewrites incoming pathname to follow any redirect rules in the contract,
 * ensuring we fetch data for the canonical target route.
 */
export const normalizePath = (pathname) => {
    const matchedRedirect = contract.redirects?.find((r) => pathname === `${contract.basePath}${r.source}`);
    if (matchedRedirect) {
        const normalized = `${contract.basePath}${matchedRedirect.destination}`;
        return normalized;
    }
    return pathname;
};
